


































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import {UserProfile} from "@api/models/UserProfile";

import Speaker from '../../session/components/Speaker.vue';

import { ArrayHelpers } from '../../../common/ArrayHelpers';
import UpBtn from '../../../assets/svg/arrow-rounded.svg';
import CloseBtn from '../../../assets/svg/close-rounded.svg';
import Plus from '../../../assets/svg/plus.svg';

@Component({
    components: { Speaker, UpBtn, CloseBtn, Plus }
})
export default class ParticipantsPlaceholder extends Vue {
    @Prop({required: true}) speakers: UserProfile[];

    idList: string[] = [];
    speakersById: Record<string, UserProfile> = {};

    created() {
        this.idList = this.speakers.map(item => item.id);
        this.speakersById = ArrayHelpers.keyBy(this.speakers, 'id');
    }

    get mutatedSpeakers() {
        return this.idList.map(id => this.speakersById[id]);
    }

    @Watch('speakers')
    onSpeakersChanged() {
        this.idList = this.speakers.map(item => item.id);
        this.speakersById = ArrayHelpers.keyBy(this.speakers, 'id');
    }

    onUp(index: number) {
        if (index === 0) {
            return;
        }
        const deletedIds = this.idList.splice(index, 1);
        this.idList.splice(index - 1, 0, deletedIds[0]);
        this.$emit('contactsEdited', this.idList);
    }

    onDown(index: number) {
        if (index === this.mutatedSpeakers.length - 1) {
            return;
        }
        const deletedIds = this.idList.splice(index, 1);
        this.idList.splice(index + 1, 0, deletedIds[0]);
        this.$emit('contactsEdited', this.idList);
    }

    onClose(index: number) {
        this.idList.splice(index, 1);
        this.$emit('contactsEdited', this.idList);
    }
}
